import { type CSSProperties, useRef } from 'react';
import type { DateFieldState, DateSegment } from '@react-stately/datepicker';
import { clsx } from 'clsx';
import { useDateSegment } from 'react-aria';
import styles from './segment.module.scss';

function getSegmentStyle(segment: DateSegment, style: CSSProperties | undefined): CSSProperties {
  return {
    ...style,
    minWidth: segment.maxValue !== undefined ? `${String(segment.maxValue).length}ch` : undefined,
  };
}

interface SegmentProps {
  segment: DateSegment;
  state: DateFieldState;
  withModifiedPlaceholder: boolean;
}

export function Segment({ segment, state, withModifiedPlaceholder }: SegmentProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { segmentProps } = useDateSegment(segment, state, ref);

  return (
    <div
      {...segmentProps}
      className={clsx(
        styles.segment,
        segmentProps.className,
        segment.type === 'literal' && styles.literal,
        withModifiedPlaceholder && styles.withModifiedPlaceholder,
      )}
      ref={ref}
      style={getSegmentStyle(segment, segmentProps.style)}
    >
      {segment.isPlaceholder ? segment.placeholder : segment.text}
    </div>
  );
}
